// ENUMS FOR CONTENT TYPES
export const CONTENT_TYPE = {
  FOLDER: 1,
  VIDEO: 2,
  DOCUMENT: 3,
  TEST: 4,
  // ONLY 4 CONTENT_TYPES ARE AT BACKEND, REST ARE FOR FRONTENT
  LIVE_CLASS: 5,
  ZIP: 6,
  SUBJECTIVE_TEST: 7,
  IMAGE: 8,
  PRACTICE_TEST: 12,
};

// ENUMS FOR TEST TYPES
export const TEST_TYPE = {
  ONLINE_TEST_CP: 0,
  SUBJECTIVE_TEST: 1,
  ONLINE_TEST_SDK: 2,
}

// LIMIT TO FETCH NUMBER OF CONTENT ITEMS AT A TIME
export const CONTENT_LIMIT = 10;

// CONTENT DOWNLOAD STATUS CODES
export const CONTENT_DOWNLOAD_STATUS = {
  DOWNLOAD_START: 0,
  DOWNLOAD_IN_PROGRESS: 1,
  DOWNLOAD_PAUSE: 2,
  DOWNLOAD_RESUME: 3,
  DOWNLOAD_FAILED: 4,
  DOWNLOAD_SUCCESS: 5,
  DOWNLOAD_REMOVE: 6,
  DOWNLOAD_CANCEL: 7,
  DOWNLOAD_QUEUED: 8,
  DOWNLOAD_ALREADY_DOWNLOADED: 9,
  DOWNLOAD_UNKNOWN: 10,
  DOWNLOAD_ALREADY_IN_PROGRESS: 11,
};

// DEEPLINK ACTION CONSTANTS
const deeplinkNamespace = "ACTION";

export const CONTENT_DEEPLINK_ACTIONS = {
  // OLD DEEPLINK ACTION TO VIEW IMAGE/PDF
  SCREEN_CONTENT: `SCREEN_CONTENT`,
  UTIL_TEST: `UTIL_TEST`,
  UTIL_WEBVIEW: `UTIL_WEBVIEW`,

  // OPEN CONTENT ITEM DEEPLINK ACTIONS
  ACTION_PLAY_VIDEO: `${deeplinkNamespace}_PLAY_VIDEO`,
  ACTION_OPEN_PDF: `${deeplinkNamespace}_OPEN_PDF`,
  ACTION_OPEN_IMAGE: `${deeplinkNamespace}_OPEN_IMAGE`,
  UTIL_VIDEO_V2: `UTIL_VIDEO_V2`,

  // DOWNLOAD CONTENT ITEM DEEPLINK ACTIONS
  ACTION_DOWNLOAD_FILE: `${deeplinkNamespace}_DOWNLOAD_FILE`, // NEED STORAGE PERMISSSION
  ACTION_DOWNLOAD_VIDEO_OFFLINE: `${deeplinkNamespace}_DOWNLOAD_VIDEO_OFFLINE`, // NEED STORAGE PERMISSSION
  ACTION_REMOVE_VIDEO_OFFLINE: `${deeplinkNamespace}_REMOVE_VIDEO_OFFLINE`,
  ACTION_DOWNLOAD_PDF_OFFLINE: `${deeplinkNamespace}_DOWNLOAD_PDF_OFFLINE`, // NEED STORAGE PERMISSSION
  ACTION_REMOVE_PDF_OFFLINE: `${deeplinkNamespace}_REMOVE_PDF_OFFLINE`,

  // TEST ATTEMPT WEBVIEW DEEPLINK ACTIONS
  ACTION_TEST_ATTEMPT: `${deeplinkNamespace}_TEST_ATTEMPT`, // NEED STORAGE PERMISSSION
  ACTION_TEST_REATTEMPT: `${deeplinkNamespace}_TEST_REATTEMPT`, // NEED STORAGE PERMISSSION

  // STORAGE PERMISSION DEEPLINK ACTIONS
  ACTION_CHECK_STORAGE_PERMISSION: `${deeplinkNamespace}_CHECK_STORAGE_PERMISSION`,
  ACTION_REQUEST_STORAGE_PERMISSION: `${deeplinkNamespace}_REQUEST_STORAGE_PERMISSION`,

  // GET OFFLINE DOWNLOADED ITEMS LIST DEEPLINK ACTION
  ACTION_GET_OFFLINE_DOWNLOAD_LIST: `${deeplinkNamespace}_GET_OFFLINE_DOWNLOAD_LIST`,
};

// REDUX CONSTANTS
const namespace = "COURSE_CONTENT";

const CONSTANTS = {
  LOCKED_COURSE_CONTENT: `LOCKED_${namespace}`,
  EXHAUSTED_COUNT_COURSE_CONTENT: `EXHAUSTED_COUNT_${namespace}`,

  ACTIVE_COURSE_CONTENT_FOLDER_ID: `ACTIVE_${namespace}_FOLDER_ID`,

  CLEAR_FREE_COURSE_CONTENT: `CLEAR_FREE_${namespace}`,
  GET_FREE_COURSE_CONTENT: `GET_FREE_${namespace}`,
  GET_FREE_COURSE_CONTENT_LOADER: `GET_FREE_${namespace}_LOADER`,
  GET_FREE_COURSE_CONTENT_SUCCESS: `GET_FREE_${namespace}_SUCCESS`,
  GET_FREE_COURSE_CONTENT_FAILURE: `GET_FREE_${namespace}_FAILURE`,

  GET_FREE_COURSE_CONTENT_LOAD_MORE: `GET_FREE_${namespace}_LOAD_MORE`,
  GET_FREE_COURSE_CONTENT_LOADED_MORE: `GET_FREE_${namespace}_LOADED_MORE`,

  CLEAR_COURSE_CONTENT: `CLEAR_${namespace}`,
  GET_COURSE_CONTENT: `GET_${namespace}`,
  GET_COURSE_CONTENT_LOADER: `GET_${namespace}_LOADER`,
  GET_COURSE_CONTENT_SUCCESS: `GET_${namespace}_SUCCESS`,
  GET_COURSE_CONTENT_FAILURE: `GET_${namespace}_FAILURE`,

  GET_COURSE_CONTENT_LOAD_MORE: `GET_${namespace}_LOAD_MORE`,
  GET_COURSE_CONTENT_LOADED_MORE: `GET_${namespace}_LOADED_MORE`,

  CLEAR_TRIAL_COURSE_CONTENT: `CLEAR_TRIAL_${namespace}`,
  GET_TRIAL_COURSE_CONTENT: `GET_TRIAL_${namespace}`,
  GET_TRIAL_COURSE_CONTENT_LOADER: `GET_TRIAL_${namespace}_LOADER`,
  GET_TRIAL_COURSE_CONTENT_SUCCESS: `GET_TRIAL_${namespace}_SUCCESS`,
  GET_TRIAL_COURSE_CONTENT_FAILURE: `GET_TRIAL_${namespace}_FAILURE`,

  GET_TRIAL_COURSE_CONTENT_LOAD_MORE: `GET_TRIAL_${namespace}_LOAD_MORE`,
  GET_TRIAL_COURSE_CONTENT_LOADED_MORE: `GET_TRIAL_${namespace}_LOADED_MORE`,

  CLEAR_COURSE_CONTENT_TEST_STATS: `CLEAR_${namespace}_TEST_STATS`,
  GET_COURSE_CONTENT_TEST_STATS: `GET_${namespace}_TEST_STATS`,
  GET_COURSE_CONTENT_TEST_STATS_LOADER: `GET_${namespace}_TEST_STATS_LOADER`,
  GET_COURSE_CONTENT_TEST_STATS_SUCCESS: `GET_${namespace}_TEST_STATS_SUCCESS`,
  GET_COURSE_CONTENT_TEST_STATS_FAILURE: `GET_${namespace}_TEST_STATS_FAILURE`,
  GET_TEST_LEADERBOARD_STATS: `GET_${namespace}_TEST_LEADERBOARD_STATS`,

  CLEAR_PREVIEW_VIDEO_CONTENT: `CLEAR_PREVIEW_VIDEO_CONTENT`,
  ADD_PREVIEW_VIDEO_CONTENT: `CLEAR_PREVIEW_VIDEO_CONTENT`,
  ADD_PREVIEW_VIDEO_CONTENT_LOADER: `CLEAR_PREVIEW_VIDEO_CONTENT_LOADER`,
  ADD_PREVIEW_VIDEO_CONTENT_SUCCESS: `CLEAR_PREVIEW_VIDEO_CONTENT_SUCCESS`,
  ADD_PREVIEW_VIDEO_CONTENT_FAILURE: `CLEAR_PREVIEW_VIDEO_CONTENT_FAILURE`,

  SHOW_NOTES_MODAL: `SHOW_NOTES_MODAL`,
  SET_NOTES_MODAL_CONTENT: `SET_NOTES_MODAL_CONTENT`,

  GET_CONTENT_ATTACHMENTS: `GET_CONTENT_ATTACHMENTS`,
  GET_CONTENT_ATTACHMENTS_LOADER: `GET_CONTENT_ATTACHMENTS_LOADER`,
  GET_CONTENT_ATTACHMENTS_SUCCESS: `GET_CONTENT_ATTACHMENTS_SUCCESS`,
  GET_CONTENT_ATTACHMENTS_FAILURE: `GET_CONTENT_ATTACHMENTS_FAILURE`,

  IDFY_PREPURCHAGE_OTP_GENERATE: `${namespace}IDFY_PREPURCHAGE_OTP_GENERATE`,
  IDFY_PREPURCHAGE_OTP_GENERATE_SUCCESS: `${namespace}IDFY_PREPURCHAGE_OTP_GENERATE_SUCCESS`,
  IDFY_PREPURCHAGE_OTP_GENERATE_SERVICE: `${namespace}IDFY_PREPURCHAGE_OTP_GENERATE_SERVICE`,
  IDFY_PREPURCHAGE_OTP_RE_GENERATE_SERVICE: `${namespace}IDFY_PREPURCHAGE_OTP_RE_GENERATE_SERVICE`,
  IDFY_PREPURCHAGE_OTP_VERIFY: `${namespace}IDFY_PREPURCHAGE_OTP_VERIFY`,
  IDFY_PREPURCHAGE_OTP_VERIFY_SERVICE : `${namespace}IDFY_PREPURCHAGE_OTP_VERIFY`,
  IDFY_POSTPURCHAGE_IDENTITY_VERIFY: `${namespace}IDFY_POSTPURCHAGE_IDENTITY_VERIFY`,
  IDFY_POSTPURCHAGE_IDENTITY_VERIFY_SERVICE: `${namespace}IDFY_POSTPURCHAGE_IDENTITY_VERIFY_SERVICE`,
  polingSubmitIdfyDoc : `${namespace}polingSubmitIdfyDoc`,
  IDFY_PREPURCHAGE_OTP_GENERATE_STATE: `${namespace}IDFY_PREPURCHAGE_OTP_GENERATE_STATE`,
  
  GET_SUBJECTIVE_TEST_DOWNLOAD_URL: `${namespace}GET_SUBJECTIVE_TEST_DOWNLOAD_URL`,

  GET_CONTENT_MARK_AS_DONE: `${namespace}GET_CONTENT_MARK_AS_DONE`,
  GET_CONTENT_MARK_AS_DONE_SUCCESS: `${namespace}GET_CONTENT_MARK_AS_DONE_SUCCESS`,
  GET_CONTENT_MARK_AS_DONE_API: `${namespace}GET_CONTENT_MARK_AS_DONE_API`,

  MARK_CONTENT_AS_DONE: `${namespace}MARK_CONTENT_AS_DONE`,
  MARK_CONTENT_AS_DONE_SUCCESS: `${namespace}MARK_CONTENT_AS_DONE_SUCCESS`,
  MARK_CONTENT_AS_DONE_API: `${namespace}MARK_CONTENT_AS_DONE_API`,

  PATCH_CONTENT_MARK_AS_DONE: `${namespace}PATCH_CONTENT_MARK_AS_DONE`,
  PATCH_CONTENT_MARK_AS_DONE_SUCCESS: `${namespace}PATCH_CONTENT_MARK_AS_DONE_SUCCESS`,
  PATCH_CONTENT_MARK_AS_DONE_API: `${namespace}PATCH_CONTENT_MARK_AS_DONE_API`,
};

export default CONSTANTS;
